import { render, staticRenderFns } from "./LanguageRegister.vue?vue&type=template&id=4713e892"
import script from "./LanguageRegister.vue?vue&type=script&lang=js"
export * from "./LanguageRegister.vue?vue&type=script&lang=js"
import style0 from "./LanguageRegister.vue?vue&type=style&index=0&id=4713e892&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports